"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoronaExtractor = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var Resources_1 = require("../../Resources");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var CoronaExtractor = (function (_super) {
    __extends(CoronaExtractor, _super);
    function CoronaExtractor() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.CORONA_EXTRACTOR,
            cost: 10,
            tags: [Tags_1.Tags.SPACE, Tags_1.Tags.ENERGY],
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.SCIENCE, 4); }),
            metadata: {
                cardNumber: 'C06',
                description: 'Requires 4 science tags. Increase your energy production 4 steps.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) { return b.production(function (pb) { return pb.energy(4).digit; }); }),
            },
        }) || this;
    }
    CoronaExtractor.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.ENERGY, 4);
        return undefined;
    };
    return CoronaExtractor;
}(Card_1.Card));
exports.CoronaExtractor = CoronaExtractor;
//# sourceMappingURL=CoronaExtractor.js.map